import {RUBICS_CUBE_COLUMNS} from '../../../../models/column-styles.interface';

export enum ViewState {
  SELECT_METADATA = 'selectMetadata',
  SELECT_COLUMNS = 'selectColumns',
  ADD_FILTERS = 'addFilters'
}

export enum SelectableItems {
  METADATA_TYPE = 'metadataType',
  COLUMN = 'column'
}

export type ViewStateType =
  | ViewState.SELECT_METADATA
  | ViewState.SELECT_COLUMNS
  | ViewState.ADD_FILTERS;

export const summaryInfoObjectValue = RUBICS_CUBE_COLUMNS.SUMMARY_INFO_OBJECT_COLUM;

export enum GridEditTemplate {
  string = 'string',
  integer = 'integer',
  boolean = 'boolean',
  date = 'date',
  predefined = 'predefined',
  query = 'query',
  tags = 'tags',
  predefinedList = 'predefinedList',
  node_assignee = 'node_assignee',
  is_exists = 'isExists',
  user = 'user'
}

export const numberFilterOperators = [
  {title: 'Is equal to', value: 'eq'},
  {title: 'Is not equal to', value: 'neq'},
  {title: 'Is greater than or equal to', value: 'gte'},
  {title: 'Is greater than', value: 'gt'},
  {title: 'Is less than or equal to', value: 'lte'},
  {title: 'Is less than', value: 'lt'},
  {title: 'Is between', value: 'range'}
];

export const defaultNumberOperator = {title: 'Is equal to', value: 'eq'};

export const stringFilterOperators = [
  {title: 'Is equal to', value: 'eq'},
  {title: 'Is not equal to', value: 'neq'},
  {title: 'Contains', value: 'contains'},
  {title: 'Does not contain', value: 'doesnotcontain'},
  {title: 'Starts with', value: 'startswith'}
];

export const defaultStringOperator = {title: 'Is equal to', value: 'eq'};

export const booleanFilterOperators = [
  {title: 'Is equal to', value: 'eq'},
  {title: 'Is not equal to', value: 'neq'}
];

export const queryFilterOperators = [
  {title: 'Is one of', value: 'eq'},
  {title: 'Is not one of', value: 'neq'}
];

export const defaultQueryOperator = {title: 'Is equal to', value: 'eq'};

export const defaultBooleanOperator = {title: 'Is equal to', value: 'eq'};

export const dateFilterOperators = [
  {title: 'From', value: 'gt'},
  {title: 'To', value: 'lt'},
  {title: 'Is between', value: 'range'}
];

export const userSearchOperators = [
  {title: 'Is equal to', value: 'eq'},
  {title: 'Is not equal to', value: 'neq'},
  {title: 'Contains', value: 'contains'}
];

export const defaultDateOperator = {title: 'From', value: 'gt'};

export const datePickerPlaceholder = 'MM-DD-YYYY';

export const datePickerConfig = {
  appendTo: 'body',
  format: 'MM-DD-YYYY',
  firstDayOfWeek: 'mo'
};

export const STARTS_WITH_MIN_CHARACTERS = 4;

export const summaryDescriptionCnaFilterOperators = [
  {title: 'Is equal to', value: 'eq'},
  {title: 'Is not equal to', value: 'neq'},
  {title: 'Contains', value: 'contains'},
  {title: 'Does not contain', value: 'doesnotcontain'},
  {title: 'Starts with', value: 'startswith'},
  {title: 'Is exists', value: 'isExists'}
];

export const SUMMARY_COLUMNS = ['SUMMARY', 'summary'];
export const DESCRIPTION_COLUMNS = ['DESCRIPTION', 'description'];

export const isExistsOptions = [
  {title: 'Yes', value: 'true'},
  {title: 'No', value: 'false'}
];
